import api from './api';

export const getUserAugments = () => api.get('/api/v1/augments');

export const selectAugment = ({ augmentId }) => api.put('/api/v1/augments', { augmentId });
